"use client";

import { useState } from "react";
import { Pencil } from "lucide-react";
import "../Css/PreviewMainForm.css";
import { useDispatch } from "react-redux";
import { setActiveTabIndex } from "../actions";
import {
  server_post_data,
  oilcheck_car_data,
} from "../../ServiceConnection/serviceconnection";
import { handleError, handleSuccess } from "../../CommonJquery/CommonJquery";
import { useNavigate } from "react-router-dom";

const PreviewOilCheckForm = ({
  onBack,
  MaintainanceData,
  cardata,
  ImageLink,
  FromComeData,
}) => {
  const dispatch = useDispatch();
  const [showLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const navigate = useNavigate();
  console.log("MaintainanceData", MaintainanceData);

  const handleEdit = (section) => {
    switch (section) {
      case "odometerVehicleImages":
        dispatch(setActiveTabIndex(0));
        break;
      case "damageAdditionalNotes":
        dispatch(setActiveTabIndex(1));
        break;
      default:
      //console.log("Invalid section");
    }
  };

  const handleclickSubmit = async () => {
    setShowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("car_id", cardata.primary_id);
    fd.append("step_for_repairing", 2);
    fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
    fd.append("save_or_edit_type", FromComeData);

    await server_post_data(oilcheck_car_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess(Response.data.message);
          navigate("/Maintanance");
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  const labels = ["Front Left", "Front Right", "Back Left", "Back Right"];
  // Odometer & Vehicle Images Section
  const OdometerVehicleImagesSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">General Info Checklist</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("odometerVehicleImages")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Done By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.assign_staff_name || "N/A"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Issues with car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.name_and_issue || "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Damage & Additional Notes Section
  const DamageAdditionalNotesSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Oil Check Checklist</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("damageAdditionalNotes")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Level</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_level || "0.00"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Quality
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_quantity || "N/A"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Quantity Added
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_added_quantity || "N/A"}
                </span>
              </div>
            </div>
            {/* <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Notes</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.additional_notes || "N/A"}
                </span>
              </div>
            </div> */}
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Cap Picture
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="row justify-content-end">
                  <div className="col-3">
                    <img
                      src={ImageLink + MaintainanceData.picture_of_closed_oil}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                      alt={`Oil Cap`}
                      className="img-fluid step_8_img_view"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="final-checks-container">
      <div className="form-header mb-4">
        <h2 className="form-title mb-2">
          Final Oil Check Inspection Checklist
        </h2>
        <p className="form-subtitle text-muted">
          Verify all Oil Check inspections have been completed before submitting
        </p>
      </div>

      {OdometerVehicleImagesSection()}
      {DamageAdditionalNotesSection()}

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>
        <button
          className="btn next__button"
          onClick={handleclickSubmit}
          disabled={showLoaderAdmin}
        >
          {showLoaderAdmin ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default PreviewOilCheckForm;
